import { useState } from "react";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { useUrlSearchParams } from "use-url-search-params";

import { useServiceDocs } from "modules/serviceRegister/hooks";

import Table from "components/Table";

import Container from "components/Container";
import Button from "components/Button";
import FilterList from "./FilterList";

import cls from "./Stats.module.scss";
import Spacer from "../../../../components/Spacer";
import Title from "components/Title";

const Stats = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [params, setParams] = useUrlSearchParams();
  const [search, setSearch] = useState(0);

  const { data, isLoading } = useServiceDocs({ orgId: params.organization_id, search });

  const columns = [
    {
      title: "№",
      render: (_, __, index) => index + 1,
    },
    {
      title: t("column_service_name"),
      dataIndex: ["serviceName", "uz"],
      key: "serviceName",
      render: (value) => (
        <span
          onClick={() =>
            navigate(`/service-register/stats`)
          }
        >
          {value}
        </span>
      ),
    },
    {
      title: t("organization"),
      dataIndex: ["organization", "name", "uz"],
      key: "organization",
    },
    {
      title: t("document_count"),
      dataIndex: "count",
      key: "count",
      width: 100,
    },
  ];

  return (
    <section className={cls.section}>
      <Container>
        <Title
          align="center"
          text={t("service_register_stats")}
        />
        <Spacer size={20} />

        <FilterList {...{ params, setParams, setSearch }}/>

        <Spacer size={20} />

        <Table
          rowKey="id"
          columns={columns}
          dataSource={data}
          loading={isLoading}
          pagination={false}
        />

        <div className={cls.btn}>
          <Button onClick={() => navigate('/service-register/stats')}>
            {t('action_more')}
          </Button>
        </div>
      </Container>
    </section>
  );
};

export default Stats;
